import { Accordion } from "@app/shared/Accordion"
import { FC, useContext } from "react"
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import InfoIndicator from "@app/shared/InfoIndicator";

export const ContractEntityProfileProviders: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const { selectedContractEntity } = providerHubContext;
  const { enabledFeatureFlags } = useContext(FeatureFlagContext);

  return (
    <Accordion title={enabledFeatureFlags.has(Features.HOSPITAL_PROFILE) ? "Employed Providers" : "Providers"} testId="provider-profile__providers-accordion" defaultOpen={true} className="provider-profile__overview">
      <dl>
        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-title">Category</dt>
          <dd className={`provider-profile__overview-title`}>
            Number of Providers
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Servicing Providers <InfoIndicator className={"informational-indicator"} tooltipWidth="320px" tooltipTitle={<>Total servicing providers are calculated based on access point data per provider.<br /><br />Servicing provider counts may not equal in-network and out-of-network totals as providers may have access points in both categories.</>} /></dt>
          <dd className="provider-profile__overview-value">
            {selectedContractEntity.filteredServicingProviders}
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">In-network Providers</dt>
          <dd className="provider-profile__overview-value">
            {selectedContractEntity.filteredInNetworkServicingProviders}
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Out-of-network Providers</dt>
          <dd className="provider-profile__overview-value">
            {selectedContractEntity.filteredOutOfNetworkServicingProviders}
          </dd>
        </div>
      </dl>
    </Accordion>
  )
};